import "./error.scss";
import { useNavigate } from "react-router-dom";
import { BrandButton } from "./form/buttons";
import { logoutUser } from "./user";

const LoadError = () => {
  const navigate = useNavigate();

  const logoutAndGoHome = () => {
    logoutUser();
    navigate("/");
  };

  return (
    <div className="loadError">
      <div className="errorContent">
        <p>There was an error loading your page. Please login and try again.</p>
        <BrandButton onClick={logoutAndGoHome}>GO HOME</BrandButton>
      </div>
    </div>
  );
};
export default LoadError;
